import { RangeCalendarNext_default } from "../RangeCalendar/RangeCalendarNext.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DateRangePicker/DateRangePickerNext.vue?vue&type=script&setup=true&lang.ts
var DateRangePickerNext_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DateRangePickerNext",
	props: {
		nextPage: {
			type: Function,
			required: false
		},
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(RangeCalendarNext_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx((slotProps) => [renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps(slotProps)))]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DateRangePicker/DateRangePickerNext.vue
var DateRangePickerNext_default = DateRangePickerNext_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DateRangePickerNext_default };
//# sourceMappingURL=DateRangePickerNext.js.map